import styled from "styled-components";
import { FlexColumnDiv } from "./common.styles";
export const SmartAuthProgressViewParent = styled(FlexColumnDiv) `
    margin: 80px 0;
    align-items: center;
    gap: 48px;
`;
export const SmartAuthProgress = styled.div ``;
export const SmartAuthError = styled.div ``;
export const SmartAuthSpinnerHolder = styled.div ``;
